import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { GetRecPlanNameSearchReportQuery, GetRecPlanNameSearchReportResponse } from '../viewmodels/ISearchServiceReg';
import { SearchReportResponseBase } from '../viewmodels/ISearchService';

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}



@Injectable()
export class ReportViewerESService {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  myAppUrl: string = "";
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getRecPlanNameSearchReport(search: GetRecPlanNameSearchReportQuery): Observable<GetRecPlanNameSearchReportResponse> {
    //let url_ = this.myAppUrl + "api/ES/GetSearchPlanRoom2Report";
    let url_ = this.myAppUrl + "api/ES/GetSearchPlanRoom2Report";
    //let url_ = this.myAppUrl + "api/CoreData/GetPropertySearchReportResult";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe<GetRecPlanNameSearchReportResponse>(_observableMergeMap((response_: any) => {
      return this.processSearchReportResponse(response_);
    })).pipe<GetRecPlanNameSearchReportResponse>(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRecPlanNameSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRecPlanNameSearchReportResponse>><any>_observableThrow(response_);

    }));


  }

  processSearchReportResponse(response: HttpResponseBase): Observable<SearchReportResponseBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchReportResponseBase.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SearchReportResponseBase>(<any>null);

  }

  blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
      if (!blob) {
        observer.next("");
        observer.complete();
      } else {
        let reader = new FileReader();
        reader.onload = event => {
          observer.next((<any>event.target).result);
          observer.complete();
        };
        reader.readAsText(blob);
      }
    });
  }
  throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
      return _observableThrow(result);
    else
      return _observableThrow(new SwaggerException(message, status, response, headers, null));
  }


}
